const LIFF_CHANNEL_ID = 1654010378;
const LIFF_ID = '1654010378-A4K8gWop';

module.exports = {LIFF_CHANNEL_ID, LIFF_ID};